import React, { useState, useEffect } from "react";
import content from "./json/content.json";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { ThreeDots } from "react-loader-spinner";
import GettingStarted from "./getting-started";
import Callback from "./callback";
import Methodapi from "./methods";
import Header from "./Header";
import Chatborde from "../../pages/chatborde";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

export default function Home() {
  const [contentpera, setContentPera] = useState([]);
  const [listdata, setlistdata] = useState([]);
  const [contentpera1, setContentPera1] = useState([]);
  const { promiseInProgress } = usePromiseTracker();
  const { t } = useTranslation();
  const [allLanguage, setAllLanguage] = useState("english");
  
  // Set language according current local
  useEffect(() => {
    i18next.changeLanguage(navigator.language === 'en-US' ? 'en' : 'fr'); // Change the i18next language
    localStorage.setItem("handleSelectedLanguage", navigator.language === 'en-US' ? 'english' : 'guinea');
  }, [navigator.language]);

  // Get handleSelectedLanguage from localStorage
  useEffect(() => {
    const storeHandleSelectedLanguage = localStorage.getItem('handleSelectedLanguage');
    if (storeHandleSelectedLanguage) {
      setAllLanguage(storeHandleSelectedLanguage); // Update state
    }
  }, [localStorage.getItem('handleSelectedLanguage')]); // Runs only on mount

  useEffect(() => {
    // Simulate async loading with promise tracking
    trackPromise(
      new Promise((resolve) => {
        setTimeout(() => {
          setContentPera(content[allLanguage === "english" ? 'en' : 'fr'].introduction[0].pracontent || []);
          setlistdata(content[allLanguage === "english" ? 'en' : 'fr'].introduction[0].list);
          setContentPera1(content[allLanguage === "english" ? 'en' : 'fr'].introduction[0].pracontent1 || []);
          resolve();
        }, 1000); // optional simulated delay
      })
    );
  }, [allLanguage]);

  return (
    <>
      <Header />
      <div className="dashboard-wrapper">
        {promiseInProgress ? (
          <div className="loader-overlay">
            <ThreeDots
              height="80"
              width="80"
              color="#fc7a34"
              ariaLabel="loading"
            />
          </div>
        ) : (
          <div className="">
            <h4 className="h4-heading">{t("main.developerDocuments.Introduction")}</h4>
            <div className="heading-box">
              {contentpera.map((para, index) => (
                <p key={index} className="p-pera">
                  {para}
                </p>
              ))}
              <ol className="order-list-ind">
                {listdata.map((para, index) => {
                  return (
                    <li key={index} className="p-pera">
                      {para}
                    </li>
                  );
                })}
              </ol>
              {contentpera1.map((para, index) => (
                <p key={index} className="p-pera">
                  {para}
                </p>
              ))}
              <GettingStarted />
              <Callback />
              <Methodapi />
            </div>
          </div>
        )}
        <Chatborde />
      </div>
      <div className="flex w-full flex-col items-center justify-center px-1  lg:px-8 xl:flex-row">
        <h5 className="text-center text-sm font-medium text-gray-600 sm:!mb-0 ">
          <p className="text-center text-sm text-gray-800 dark:text-gray-600 sm:!mb-0">
            ©{1900 + new Date().getYear()} {t('main.EventBooking.devPortalFooterText')}
          </p>
        </h5>
      </div>
    </>
  );
}
